import firebase from '../firebaseConfig';

// Ship uncaught browser errors to the backend (metadata only) so a "the
// page crashed" report can be diagnosed. Best-effort: never throws, rate
// limited so a render loop cannot flood the collection.
const API = process.env.REACT_APP_UPLOAD_API || '';
let sent = 0;
let windowStart = Date.now();

export async function reportClientError(error, extra = {}) {
  try {
    if (Date.now() - windowStart > 60_000) { sent = 0; windowStart = Date.now(); }
    if (sent >= 5 || !API) return;
    sent += 1;
    const user = firebase.auth().currentUser;
    if (!user) return;
    const token = await user.getIdToken();
    await fetch(`${API}/legal/client-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        message: String(error?.message || error || ''),
        stack: String(error?.stack || ''),
        path: window.location.pathname,
        ua: navigator.userAgent,
        build: process.env.REACT_APP_BUILD || '',
        ...extra,
      }),
      keepalive: true,
    });
  } catch { /* best effort */ }
}

export function installGlobalErrorReporting() {
  window.addEventListener('error', (e) => reportClientError(e.error || e.message, { kind: 'window.error' }));
  window.addEventListener('unhandledrejection', (e) => reportClientError(e.reason, { kind: 'unhandledrejection' }));
}
